import script from "./RegistrationDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationDialog.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__